var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusFallingLtr = function SvgPlusFallingLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M63.1 66.1H51.9V54.9a1.899 1.899 0 1 0-3.8 0v11.2H36.9a1.9 1.9 0 0 0 0 3.8h11.2v11.2a1.9 1.9 0 0 0 3.8 0V69.9h11.2a1.9 1.9 0 1 0 0-3.8",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M50 39c-16.016 0-29 12.984-29 29s12.984 29 29 29 29-12.984 29-29-12.984-29-29-29m0 3.475c14.097 0 25.525 11.428 25.525 25.525S64.097 93.525 50 93.525 24.475 82.097 24.475 68 35.903 42.475 50 42.475M31 13.15c0-1.187.895-2.15 2-2.15 1.085 0 1.968.929 2 2.087V36.85c0 1.187-.895 2.15-2 2.15-1.085 0-1.968-.929-2-2.087zm17-8C48 3.964 48.895 3 50 3c1.085 0 1.968.929 2 2.087V28.85c0 1.187-.895 2.15-2 2.15-1.085 0-1.968-.929-2-2.087zm17 8c0-1.187.895-2.15 2-2.15 1.085 0 1.968.929 2 2.087V36.85c0 1.187-.895 2.15-2 2.15-1.085 0-1.968-.929-2-2.087z",
    clipRule: "evenodd"
  })));
};
export default SvgPlusFallingLtr;